













































import { Auth } from '@finx/web-repository/src/services/Oidc'
import { Component, Vue } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import LogoutConfigStore from '@/store/LogoutConfigStore'

@Component
export default class ViewNoDefaultRoute extends Vue {
  get logoutConfigStore() {
    return getModule(LogoutConfigStore, this.$store)
  }

  async logout() {
    await this.logoutConfigStore.authLogout(this.$user.profile.sub)
  }
}
